import TabComponent from 'components/_parts/atoms/tab/Wla';
import { TabComponentTypes } from 'components/types/company';
import { useMemo, useState } from 'react';
import Directorate from 'components/company/revamp/parts/setting/directorate/list';
import { useTranslation } from 'react-i18next';
import JobLevel from 'components/company/revamp/parts/setting/jobLevel/list/jobLevel';
import Region from 'components/company/revamp/parts/setting/region/list';
import CustomOrgParameter from 'components/company/revamp/parts/setting/customOrg/list';
import { TabOrganization } from '../dummySetting';
import { useFetchOrganizationGroup } from './useFetch';

interface PropsType {
  isBoardList? : boolean
}

function Organization({ isBoardList = false }: PropsType) {
  const { t } = useTranslation();
  const dataTab = TabOrganization(isBoardList);
  const [tab, setTab] = useState(1);
  const activeTab = dataTab.find((item) => item.id === tab)?.value || 1;
  useFetchOrganizationGroup(activeTab);

  const handleTab = (val: TabComponentTypes) => {
    setTab(val.id);
  };

  const memoContent = useMemo(() => {
    switch (activeTab) {
      case 1:
        return <Directorate t={t} />;
      case 2:
        return <JobLevel t={t} />;
      case 3:
        return <Region t={t} />;
      case 4:
        return <CustomOrgParameter t={t} />;

      default:
        return <Directorate t={t} />;
    }
  }, [tab]);

  return (
    <div>
      <TabComponent
        tab={tab}
        dataTab={dataTab}
        handleClickTab={handleTab}
      />
      <div className="tw-mt-4">
        {memoContent}
      </div>
    </div>
  );
}

export default Organization;
